export enum tagTypes {
    tag = 10,
    business = 20,
}
